// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1ynli","inputWrap":"styles_inputWrap__2K-sC","input":"styles_input__2tXSR"};